export var balihai = '#879baa';
export var catskill = '#ebf0f5';
export var denim = '#3f51b5';
export var dustygray = '#9bafbe';
export var endeavour = '#0168b0';
export var mercury = '#dfe6ed';
export var mineshaft = '#353d43';
export var tundora = '#23292d';
export var scienceblue = '#387cbe';
export var white = '#ffffff';
